// src/v3/interactions/chevron-down.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var ChevronDownIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "ChevronDownIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M19.1346 9.13891L12.4668 15.8067C12.4049 15.8687 12.3313 15.9179 12.2504 15.9515C12.1694 15.985 12.0827 16.0023 11.995 16.0023C11.9074 16.0023 11.8206 15.985 11.7397 15.9515C11.6587 15.9179 11.5852 15.8687 11.5233 15.8067L4.85544 9.13891C4.73032 9.01379 4.66003 8.8441 4.66003 8.66716C4.66003 8.49021 4.73032 8.32052 4.85544 8.1954C4.98056 8.07029 5.15025 8 5.32719 8C5.50413 8 5.67382 8.07029 5.79894 8.1954L11.995 14.3923L18.1911 8.1954C18.2531 8.13345 18.3266 8.08431 18.4076 8.05078C18.4885 8.01726 18.5753 8 18.6629 8C18.7505 8 18.8372 8.01726 18.9182 8.05078C18.9991 8.08431 19.0727 8.13345 19.1346 8.1954C19.1966 8.25736 19.2457 8.3309 19.2792 8.41185C19.3128 8.49279 19.33 8.57954 19.33 8.66716C19.33 8.75477 19.3128 8.84152 19.2792 8.92246C19.2457 9.00341 19.1966 9.07695 19.1346 9.13891Z"
  }
) });

export {
  ChevronDownIcon
};
